import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import notesActionCreators from '../../../store/notes/action-creators';
import notesSelectors from '../../../store/notes/selectors';
import NoteForm from './NoteForm';

const NoteEdit = (props) => {
  // ----------------------
  // Methods
  // ----------------------

  function onSave(formData) {
    props.updateNote({
      content: formData.content,
      noteGuid: props.editingNote.guid,
    });
  }

  // ----------------------
  // Render
  // ----------------------

  return (
    <Fragment>
      <NoteForm
        initialValues={props.editingNote}
        onSave={formData => onSave(formData)}
      />
    </Fragment>
  );
};

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    editingNote: notesSelectors.editingNote(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateNote: (formData) => {
      dispatch(notesActionCreators.updateNote(formData));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NoteEdit);

